import Icon from '../../components/Icon.vue'

Icon.register({"brands/freebsd":{"width":448,"height":512,"paths":[{"d":"M303.7 96.2C314.8 85.1 419.2 19.2 442.9 43 466.6 66.7 400.8 171.1 389.7 182.2 378.6 193.3 350.3 183.1 326.6 159.3 302.8 135.6 292.5 107.3 303.7 96.2zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1-11 57.7 12.7 110.5 33.5 146.8 52 114.6 78.3 87.5 109.9 68.1zM406.7 174C410 185.3 409.4 194.7 404 200.1 383.7 220.4 316.5 173.1 294.7 130 276.7 97.7 283.6 76.6 309.6 81.3 315.3 77.7 321.9 73.7 329.2 69.7 299.4 54.2 265.6 45.4 229.7 45.4 110.6 45.4 14.1 141.9 14.1 261 14.1 380 110.6 476.6 229.7 476.6S445.3 380.1 445.3 261C445.3 222.6 435.2 186.5 417.6 155.2 413.7 162.2 410 168.5 406.7 174z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/freebsd.js
// module id = null
// module chunks = 